import React from "react";
import "../Styles/CustomerStory.scss";
import { ArrowRight } from "lucide-react";

// Exact SVG double quote icon matching user screenshot
const CustomQuoteIcon = ({ size = 22, color = "#F05742" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M7 8a2.5 2.5 0 1 0 0 5h1a1 1 0 0 0 1-1V9.5a1.5 1.5 0 0 0-1.5-1.5H7zm0 5c0 2.8-1.5 4.5-3.5 5.5" />
    <path d="M17 8a2.5 2.5 0 1 0 0 5h1a1 1 0 0 0 1-1V9.5a1.5 1.5 0 0 0-1.5-1.5H17zm0 5c0 2.8-1.5 4.5-3.5 5.5" />
  </svg>
);

const CustomerStory = ({ content = {} }) => {
  const { stories = [] } = content;

  return (
    <div className="customerStory-wrapper">
      <div className="customerStory-container">
        {/* Apple Editorial Header Meta */}
        <div className="customerStory-header-meta">
          <span className="customerStory-label-apple">CUSTOMER STORIES</span>
          <h2 className="customerStory-main-title">Trusted by Enterprise Leaders</h2>
          <p className="customerStory-main-sub">
            See how industry pioneers transform customer engagement with our AI solutions.
          </p>
        </div>

        {/* Apple Spatial Ceramic Cards 3-Column Grid */}
        <div className="customerStory-card-wrapper">
          {stories.map((story, index) => (
            <div
              key={index}
              className="customerStory-card"
              onClick={() => {
                if (story.url) {
                  window.open(story.url, "_blank");
                }
              }}
            >
              {/* Double Quote Circle Badge */}
              <div className="customerStory-quote-badge">
                <CustomQuoteIcon size={22} color="#F05742" />
              </div>

              {/* Quote Text Content */}
              <div className="customerStory-content">
                <p className="customerStory-description">"{story.text}"</p>
              </div>

              {/* Apple Link CTA Footer */}
              <div className="customerStory-card-footer">
                <div className="customerStory-link-btn">
                  <span>Read Case Study</span>
                  <ArrowRight size={15} className="customerStory-btn-arrow" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomerStory;
